import { Metamodel } from 'app/model/base/model';
import { StoreWriteSettings } from './store-write-settings';
import { IAttribute, SftpServerLinkedService } from 'shell-models-lib';


@Metamodel.model({
    name: 'SftpWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(SftpServerLinkedService)
    }
})

export class SftpStoreWriteSettings extends StoreWriteSettings {
    public static readonly OPERATION_TIMEOUT: IAttribute;
    public static readonly USE_TEMPFILE_RENAME: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'OPERATION_TIMEOUT',
        display: stringResources.ModelName_OperationTimeout
    })
    public operationTimeout: number = 60;

    @Metamodel.attribute({
        templatable: true,
        association: 'USE_TEMPFILE_RENAME',
        display: stringResources.SFTP_UseTempFileRename_Label
    })
    public useTempFileRename: boolean = true;
}
